<script>
   /****************************************************************
   * SensitivityPlot                                               *
   * --------------------                                          *
   * shows plot with sensitivity values vs. number of PCs          *
   *****************************************************************/

   import { Segments, Rectangles } from 'svelte-plots-basic/2d';

   export let alpha;       // expected alpha value
   export let nCompMax     // max number of components
   export let nObj;        // number of objects
   export let ciTop;
   export let ciBottom;
   export let ciMargin;


   let ciLine, ciHeight;
   $: if (alpha) {
      ciLine = 1 - alpha/100;
      ciMargin = 2 * Math.sqrt(alpha/100 * (1 - alpha/100) / nObj);
      ciTop = ciLine + ciMargin;
      ciBottom = ciLine - ciMargin;
      ciHeight = ciMargin * 2;
   } else {
      ciLine = null;
      ciTop = null;
      ciMargin = 0;
      ciBottom = null;
   }
</script>

{#if ciTop && ciBottom }
<Rectangles left={[0]} width={[nCompMax + 1]} top={[ciTop]} height={[ciHeight]} faceColor='#00000010'/>
<Segments xStart={[0]} xEnd={[nCompMax + 1]} yStart={[ciLine]} yEnd={[ciLine]} lineColor='#00000050' lineType={2}/>
{/if}